import { Component, Output, EventEmitter } from '@angular/core';
import {TBaseCommonComponent} from '../../../../shared/components/base-components/t-base-common.component';
import {CommonService} from '../../../../shared/services/common.service';
import {AuthenticationService} from '../../../../shared/services/authentication.service';
import {APPLICATION_ROUTES_CONSTANTS} from '../../../../core/constants/application-routes.constants';
import {LogoComponent} from '../../../../shared/components/logo/logo.component';
import {ThemeToggleComponent} from '../../../../shared/components/theme-toggle/theme-toggle.component';

@Component({
  selector: 'app-topbar',
  standalone: true,
  templateUrl: './topbar.component.html',
  imports: [
    LogoComponent,
    ThemeToggleComponent
  ],
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent extends TBaseCommonComponent {
  @Output() menuToggle = new EventEmitter<void>();

  isLanguageMenuOpen = false;
  isProfileMenuOpen = false;

  constructor(
    private authenticationService: AuthenticationService
  ) {
    super();
  }

  onMenuClick() {
    this.menuToggle.emit();
  }

  toggleLanguageMenu() {
    this.isLanguageMenuOpen = !this.isLanguageMenuOpen;
    this.isProfileMenuOpen = false;
  }

  toggleProfileMenu() {
    this.isProfileMenuOpen = !this.isProfileMenuOpen;
    this.isLanguageMenuOpen = false;
  }

  navigateToProfile() {
    const currentRoute = this.commonService.router.url;
    const profileRoute = APPLICATION_ROUTES_CONSTANTS.ROUTES.USER.PROFILE;

    if (currentRoute !== profileRoute) {
      this.commonService.router.navigateByUrl(profileRoute);
    }
  }

  logout() {
    this.authenticationService.internalLogout();
  }
}
